<script>
import SupplierFormModal from "@/components/modals/supplier-form.vue";
export default {
    name: "ResourceDetails",
    components:{
        SupplierFormModal
    },
    props: {
        showBtn: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            resourceDetails: null,
            resourceLoading: false,
            selectedItemCategory: null,
        };
    },
    methods: {
        async getBudgetItem(row){
            await this.$store
                .dispatch("officebudgetitem/GetSingleOfficeBudgetItem", row.deliveryUnitBudgetItemId)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.deliveryUnitBudgetItem = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getApiResourceDetails(id){
            this.resourceLoading = true;
            await this.$store
                .dispatch("apiresource/GetSinglePPMPItem", id)
                .then(async (res) => {
                    await this.getBudgetItem(res.data);
                    this.resourceDetails = res.data;
                })
                .catch((err) => {
                });
            this.resourceLoading = false;
        },
        addSupplier(itemCategory){
            this.selectedItemCategory = itemCategory;
            this.$refs.supplierFormModal.onReset();
            this.$refs.supplierFormModal.modalTitle = "Create New Client From this Item Category";
            this.$bvModal.show("supplier-form-modal");
        },
        updateTable($event){
            let data = {
                supplierId: $event.data.id,
                itemCategoryIds: [this.selectedItemCategory.id]
            }
            this.$store
                .dispatch("supplier/CreateSupplierCategory", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.$bvModal.hide("resource-details-modal");
                    this.showToast("Successfully added!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
    }
};
</script>

<template>
    <b-modal
        id="resource-details-modal"
        title="Resource Details"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div v-if="resourceLoading"> 
            <div class="mb-3">
                <label for="">Item Name & Description:</label>
                <b-skeleton width="100%" height="50px" class="bg-primary bg-soft"></b-skeleton>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <label for="">Quantity:</label>
                        <b-skeleton width="100%" height="30px" class="bg-primary bg-soft"></b-skeleton>
                    </div>
                    <div class="col-md-6">
                        <label for="">Unit:</label>
                        <b-skeleton width="100%" height="30px" class="bg-primary bg-soft"></b-skeleton>
                    </div>
                </div>
             </div>
             <div class="mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <label for="">Unit Cost:</label>
                        <b-skeleton width="100%" height="30px" class="bg-primary bg-soft"></b-skeleton>
                    </div>
                    <div class="col-md-6">
                        <label for="">Total Amount:</label>
                        <b-skeleton width="100%" height="30px" class="bg-primary bg-soft"></b-skeleton>
                    </div>
                </div>
             </div>
             <div class="mb-3">
                <label>Item Category:</label>
                <b-skeleton width="100%" height="30px" class="bg-primary bg-soft"></b-skeleton>
             </div>
             <div class="mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <label for="">Type:</label>
                        <b-skeleton width="100%" height="30px" class="bg-primary bg-soft"></b-skeleton>
                    </div>
                    <div class="col-md-6">
                        <label for="">Subtype:</label>
                        <b-skeleton width="100%" height="30px" class="bg-primary bg-soft"></b-skeleton>
                    </div>
                </div>
             </div>
             <div class="mb-3">
                <label>Budget Item:</label>
                <b-skeleton width="100%" height="40px" class="bg-primary bg-soft"></b-skeleton>
             </div>
        </div>
        <div v-if="!resourceLoading && resourceDetails">
            <div class="mb-3">
                <label>Item Name &amp; Description:</label>
                <div class="form-control text-yellow">
                    <p class="font-size-15 text-yellow font-weight-bold mb-0">{{ resourceDetails.itemName }}</p>
                    <small>{{ resourceDetails.description }}</small>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <label>Quantity:</label>
                        <div class="form-control text-yellow">
                            {{ resourceDetails.totalQuantity }}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Unit:</label>
                        <div class="form-control text-yellow">
                            {{ resourceDetails.unit.shortName }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <label>Unit Cost:</label>
                        <div class="form-control text-yellow">
                            {{ formatCurrency(resourceDetails.unitCost) }}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Total Amount:</label>
                        <div class="form-control text-yellow">
                            {{ formatCurrency(resourceDetails.totalWithInflation) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label>Item Category:</label>
                <div class="d-flex">
                    <div class="form-control text-yellow">
                        {{ resourceDetails.itemCategory.name }}
                    </div>
                    <button v-if="showBtn" type="button" class="btn btn-outline-info" title="Add Supplier from this category" @click="addSupplier(resourceDetails.itemCategory)"><i class="bx bx-user-plus"></i></button>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label>Type:</label>
                    <div class="form-control text-yellow">
                        <span v-if="resourceDetails.isProcurable">Procurable</span>
                        <span v-else>{{resourceDetails.isMixed ? 'Mixed' : 'Non-procurable' }}</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label>SubType:</label>
                    <div class="form-control text-yellow">
                        {{resourceDetails.isProcurable ? resourceDetails.subType : 'N/A'}}
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label for="">Budget Item:</label>
                <div class="form-control">
                    <div
                        class="
                            d-flex
                            align-items-center
                            mb-2
                        "
                    >
                        <span
                            class="
                                badge
                                bg-secondary
                                text-white
                                py-1
                                px-2
                                me-2
                            "
                            >{{
                                resourceDetails
                                    .deliveryUnitBudgetItem
                                    .objectOfExpenditure.fundSource.sourceName
                            }}</span
                        >
                    </div>
                    <div
                        class="
                            d-flex
                            align-items-center
                            mb-2
                        "
                    >
                        <span
                            class="
                                badge
                                bg-purple
                                text-white
                                py-1
                                px-2
                            "
                            >{{
                                resourceDetails
                                    .deliveryUnitBudgetItem
                                    .objectOfExpenditure.accountGroup.fundClassification.classification
                            }}</span
                        >
                    </div>
                    <div
                        class="
                            d-flex
                            align-items-center
                        "
                    >
                        <span
                            class="
                                badge
                                bg-success
                                text-white
                                py-1
                                px-2
                                me-2
                            "
                            >{{
                                resourceDetails
                                    .deliveryUnitBudgetItem
                                    .objectOfExpenditure.accountGroup.groupName
                            }}</span
                        >
                    </div>
                </div>
            </div>
            <SupplierFormModal ref="supplierFormModal" @update-table="updateTable"></SupplierFormModal>
        </div>
    </b-modal>
</template>